import React, { useRef, useEffect } from "react";
import s from "./style.module.css";
import "./style.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import { select } from "d3-selection";
import { scaleLinear } from "d3-scale";
import { axisBottom, axisRight } from "d3-axis";
import { format } from "d3-format";
import { line, area, curveCatmullRom } from "d3-shape";
import ipTrafficData from "../../data/ipTraffic.json";
import { Text } from "@visx/text";

const margin = {
  top: 16,
  right: 40,
  bottom: 50,
  left: 10,
};

const yAxisLabels = [
  {
    value: 0,
    label: "",
  },
  {
    value: 50000,
    label: "50,000",
  },
  {
    value: 100000,
    label: "100,000",
  },
];

const AreaChart = ({ data, title, note, source, annotation, units }) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  const xAxisRef = useRef(null);
  const yAxisRef = useRef(null);

  const chartWidth = width - margin.left - margin.right;
  const chartHeight = height - margin.top - margin.bottom;

  const xScale = scaleLinear().domain([1990, 2022]).range([0, chartWidth]);

  const yScale = scaleLinear().domain([0, 160000]).range([chartHeight, 0]);

  const lineGenerator = line()
    .x((d) => xScale(d.Year))
    .y((d) => yScale(d.Value))
    .curve(curveCatmullRom.alpha(0.5));

  const areaGenerator = area()
    .x((d) => xScale(d.Year))
    .y0(() => yScale(0))
    .y1((d) => yScale(d.Value))
    .curve(curveCatmullRom.alpha(0.5));

  const xAxis = axisBottom(xScale)
    .tickSize(4)
    .tickPadding(8)
    .tickFormat(format(""))
    .tickValues([1992, 2002, 2012, 2022]);
  const yAxis = axisRight(yScale).tickSize(-chartWidth).ticks(4);

  useEffect(() => {
    select(xAxisRef.current).call(xAxis);
    select(yAxisRef.current).call(yAxis);
  });

  const dataLabels = ipTrafficData.filter((d) => d.Year % 10 == 2);

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <div style={{ position: "relative" }}>
        <svg width={width} height={500}>
          <g
            className="chart"
            transform={`translate(${margin.left}, ${margin.top})`}
          >
            <g className="g-axis">
              <g
                className="axis axis--x"
                transform={`translate(0,${chartHeight})`}
                ref={xAxisRef}
              ></g>
            </g>
            <g className="g-axis">
              <g
                className="axis axis--y"
                transform={`translate(${chartWidth}, 0)`}
                ref={yAxisRef}
              ></g>
            </g>
            <path
              d={areaGenerator(ipTrafficData)}
              stroke={"#CD546C"}
              strokeWidth={0}
              fill={"red"}
              fillOpacity={0.3}
            ></path>
            <path
              d={lineGenerator(ipTrafficData)}
              stroke={"#CD546C"}
              strokeWidth={2}
              fill={"none"}
            ></path>
            {ipTrafficData.map((d, i) => {
              return (
                <circle
                  key={`circle-${d.Year}`}
                  cx={xScale(d.Year)}
                  cy={yScale(d.Value)}
                  r={width < 770 ? 2.5 : 4}
                  fill={"#CD546C"}
                  stroke={"#ffffff"}
                  strokeWidth={1}
                ></circle>
              );
            })}
            {dataLabels.map((d) => {
              return (
                <text
                  key={"key-label-" + d.Year}
                  x={xScale(d.Year)}
                  y={yScale(d.Value)}
                  dy={-10}
                  fill={"#CD546C"}
                  textAnchor="middle"
                  fontSize={"11px"}
                  fontWeight="bold"
                >
                  {d.Year == 2022
                    ? format(",.3r")(d.Value) + " " + units
                    : format(",.3r")(d.Value)}
                </text>
              );
            })}
            <g>
              {yAxisLabels.map((d) => {
                return (
                  <text
                    key={"key-" + d.label}
                    x={xScale(2022) - 5}
                    y={yScale(d.value)}
                    dy={"-2px"}
                    dx={"2px"}
                    className={s.axisLabel}
                  >
                    {d.label}
                  </text>
                );
              })}
            </g>
          </g>
        </svg>
        <div
          className="annotation"
          dangerouslySetInnerHTML={{ __html: annotation }}
          style={{
            position: "absolute",
            top: "20px",
            width: xScale(2015) - xScale(1993),
            background: "rgba(255, 255, 255, 0.8)",
          }}
        ></div>
      </div>
    </Vizualisation>
  );
};

export default AreaChart;
